import * as types from './actionTypes';
import getAPIPath from '../../js/modules/api-location';
import handleErrors from "./handleErrors";
import { addNotification } from "./notificationActions";

export function getOrganisationSuccess(data) {
  return { type: types.GET_ORGANISATION_SUCCESS, data };
}

export function getAgeCategoriesSuccess(ageCategories) {
  return { type: types.GET_AGE_CATEGORIES_SUCCESS, ageCategories };
}

export function getOrganisation() {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/org`, {
      method: `GET`,
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .then((response) => {
      response.json().then((res) => {
        dispatch(getOrganisationSuccess(res.data));
      });
    }).catch((error) => {
      console.log(error);
      throw (error);
    });
  };
}

export function getAgeCategories() {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/age-categories`, {
      method: `GET`,
      credentials: `include`,
      header: {
        Accept: `application/json`,
      },
    })
      .then(handleErrors)
      .then((response) => {
        response.json().then((res) => {
          if (res.statusCode === 200) {
            dispatch(getAgeCategoriesSuccess(res.data));
          } else {
            dispatch(addNotification({
              message: res.message,
              level: `error`,
              autoDismiss: 0,
            }));
          }
        });
      })
      .catch((error) => { throw error; });
  };
}



// WEBPACK FOOTER //
// ./library/app/actions/organisationActions.js